export const WNXMEvents = {
  GetBalance: 'WNXM.GetBalance',
  BalanceReturned: 'WNXM.BalanceReturned',

  Approve: 'WNXM.Approve',
  ApproveCompleted: 'WNXM.ApproveCompleted',

  Allowance: 'WNXM.Allowance',
  AllowanceReturned: 'WNXM.AllowanceReturned',

  Wrap: 'WNXM.Wrap',
  WrapCompleted: 'WNXM.WrapCompleted',
}
